// /* eslint-disable react/jsx-no-target-blank */
// import { initializeApp } from 'firebase/app';
// import {
// 	addDoc,
// 	collection,
// 	getFirestore,
// 	onSnapshot,
// 	serverTimestamp,
// } from 'firebase/firestore';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './LoadingPage2.scss';

const LoadingPage2 = () => {
	const location = useLocation();
	const navigate = useNavigate();
	const score = location.state ? location.state.score : '0';
	const [showLoading, setShowLoading] = useState(true); // 로딩 애니메이션 표시 여부
	const [, setImageLoaded] = useState(false);

	// const firebaseConfig = {
	// 	apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
	// 	authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
	// 	projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
	// 	storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
	// 	messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
	// 	appId: process.env.REACT_APP_FIREBASE_APP_ID,
	// 	measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
	// };

	// const app = initializeApp(firebaseConfig);
	// const firestore = getFirestore(app);

	// const visitRef = collection(firestore, 'visits');

	useEffect(() => {
		const timer = setTimeout(() => {
			setShowLoading(false); // 3초 후에 로딩 애니메이션을 숨김
		}, 6000);

		return () => clearTimeout(timer); // 컴포넌트 언마운트 시 타이머 제거
	}, []);

	useEffect(() => {
		const marketingImage = new Image();
		marketingImage.src = '/assets/mkt_image2.gif';
		marketingImage.onload = () => {
			setImageLoaded(true);
		};
	}, []);

	const handleResultsClick = () => {
		// onSnapshot(visitRef, snapshot => {});

		// // 파이어베이스에 방문 기록 추가
		// addDoc(visitRef, {
		// 	visitedAt: serverTimestamp(),
		// });
		navigate(`/result2/${score}`); // 쿼리 문자열을 이용해 점수 전달
	};

	// useEffect(() => {
	// 	document.body.style.overflow = 'hidden';

	// 	return () => {
	// 		document.body.style.overflow = 'auto';
	// 	};
	// }, []);

	return (
		<div className="loading-container">
			<div className="loading-contents">
				<div className="loading-text-wrap">
					<div className="loading-text1">당신의 판다력을 분석 중..</div>
				</div>
				<div className="loading-subtext">3초 뒤에 결과가 나옵니다!</div>
				<a
					href="https://allvan.kr/?referrer=baotest"
					target="_blank"
					rel="noreferrer"
				>
					<div className="marketing-allbus2"></div>
				</a>
				<div className="loading-ani-button-wrap">
					{showLoading ? (
						<div className="loading-animation2"></div>
					) : (
						// <button className="loading-button" onClick={handleResultsClick}>
						<button className="loading-button2" onClick={handleResultsClick}>
							결과보기
						</button>
					)}
				</div>
			</div>
		</div>
	);
};

export default LoadingPage2;
